import { createApi } from "@reduxjs/toolkit/query/react";
import { CONFIG_VARS } from "../../constants/urlConstants/configuration";
import { createBaseQuery } from "../../shared/utils/baseQuery";

const { baseUrl, apiVersion, gatewayBaseUrl, gatewayApiVersion } = CONFIG_VARS;
const teamsBaseUrl = baseUrl["1"];

export const teamsApi = createApi({
  reducerPath: "teamsApi",
  baseQuery: createBaseQuery(teamsBaseUrl, true),
  endpoints: (builder) => ({
    downloadTeamHierarchy: builder.query({
      query: (formData) => ({
        url: `/${apiVersion}/data-imports/download-team-data`,
        method: "POST",
        body: formData,
        formData: true,
        responseHandler: (response) => response.text(),
      }),
      keepUnusedDataFor: 0,
    }),
    uploadTeamHierarchy: builder.mutation({
      query: (formData) => ({
        url: `/${apiVersion}/data-imports/upload-team-data`,
        method: "POST",
        body: formData,
      }),
      transformResponse: (response) => {
        if (response?.message === "Validation failed") {
          return {
            __isApiValidationError: true,
            skippedRecords: response["skipped record"],
            validationErrors: response.errors,
          };
        }
        return response;
      },
    }),
  }),
});

export const {
  useLazyDownloadTeamHierarchyQuery,
  useUploadTeamHierarchyMutation,
} = teamsApi;

export const userAgentsApi = createApi({
  reducerPath: "userAgentsApi",
  baseQuery: createBaseQuery(gatewayBaseUrl["1"], true),
  endpoints: (builder) => ({
    getUserAgents: builder.mutation({
      query: (data = {}) => ({
        url: `/${gatewayApiVersion}/user/agents`,
        method: "GET",
        params: {
          page: data.page || 1,
          limit: data.limit || 100,
          products: 100,
          role_ids: Object.keys(CONFIG_VARS.roleMappings[1]).join(","),
          search_text: data.search_string || "",
        },
      }),
      transformResponse: (response) => {
        if (response.error) {
          throw new Error(
            response.error.message || "Failed to fetch user agents"
          );
        }
        return {
          agents: response.agents || [],
          totalCount: response.totalCount || 0,
          totalPages: response.totalPages || 0,
          currentPage: response.currentPage || 1,
          limit: response.limit || 10,
        };
      },
    }),
  }),
});

export const { useGetUserAgentsMutation } = userAgentsApi;
